import React, { useState, useEffect } from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { collectionAllocationsSummary } from 'provider/queries/hasuraQueries'
import { ArrayField, useTranslate } from 'react-admin'
import { post as getFromHasura } from 'utils/axios'

import { normalGray, darkGray } from '../../constants/colorConstants'
import { CurrencyField } from '../fields/currencyField'
import { LocalDateField } from '../fields/localDateField'
import { PaymentPayerField } from '../fields/paymentPayerField'
import { EventPaymentList } from '../lists/eventPaymentList'
import expandableViewStyles from './styles'

const useStyles = makeStyles((theme) => ({
  ...expandableViewStyles,
  tablePanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: '18px',
    lineHeight: '21.6px',
    ...theme.mundi.font.lato700Normal,
    marginBottom: '31px',
  },
  titleTable: {
    fontSize: '18px',
    lineHeight: '21.6px',
    ...theme.mundi.font.lato700Normal,
    marginBottom: '31px',
    marginTop: '45px',
  },
  fieldName: {
    fontSize: '12px',
    lineHeight: '14.6px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
    marginBottom: '8px',
  },
  fieldValue: {
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    color: darkGray,
    marginBottom: '32px',
  },
}))

export const EventsCollectionExpandableView = (props) => {
  const classes = useStyles()
  const translate = useTranslate()
  // const { data, error } = useQuery({
  //   type: 'search',
  //   resource: 'invoices',
  //   payload: {
  //     ids:
  //       props.record.entries !== undefined
  //         ? props.record.entries
  //             .map((entry) => entry.invoiceId)
  //             .filter((invoiceId) => invoiceId !== undefined)
  //         : undefined,
  //     sort: { field: 'defaultSort', order: 'ASC' },
  //   },
  // })

  // if (error) return <Error error={error} />

  const [enhancedProps, setEnhancedProps] = useState(props)

  function normalizeEntriesData(entries, record) {
    const normalized = [
      ...entries.map((e) => ({
        ...e,
        invoiceId: e.invoice_id,
        amount: e.amount,
        currency: e.currency && 'USD',
        status: e.Status,
        date: record.deposited_at,
      })),
    ]
    return normalized
  }

  useEffect(() => {
    async function fetchEntries() {
      const entriesRes = await getFromHasura({
        payload: collectionAllocationsSummary,
        variables: {
          deposit_id: props.record.id,
        },
      })

      if (entriesRes.errors?.length) {
        console.error(JSON.stringify(entriesRes.errors[0]))
        return
      }

      const normalizedEntriesData = normalizeEntriesData(
        entriesRes.data.collection_view_allocations_summary,
        props.record
      )

      setEnhancedProps({
        ...props,
        record: {
          ...props.record,
          entries: normalizedEntriesData,
          entryIds: normalizedEntriesData.map((e) => e.reference),
        },
      })
    }

    fetchEntries()
  }, [props])

  return (
    <div className={classes.panel}>
      <div className={classes.infoColumn}>
        <PaymentPayerField
          record={enhancedProps.record}
          source="type"
          className={classes.title}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.amount')}
        </Typography>
        <CurrencyField
          record={enhancedProps.record}
          source="amount"
          className={classes.fieldValue}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.date')}
        </Typography>
        <LocalDateField
          record={enhancedProps.record}
          source={'deposited_at'}
          className={classes.fieldValue}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.description')}
        </Typography>
        <span className={classes.descriptionField}>
          {translate('resources.invoices.events.collectionReceivedDescription')}
        </span>
      </div>
      <div className={classes.tablePanel}>
        <Typography className={classes.titleTable}>
          {translate('resources.payments.messages.invoiceLinkedToEntry')}
        </Typography>
        <div className={classes.tableColumn}>
          <ArrayField source="entries" {...enhancedProps}>
            <EventPaymentList
              date={enhancedProps.record?.deposited_at}
              type="collection"
            />
          </ArrayField>
        </div>
      </div>
    </div>
  )
}
